"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Discount;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("@chakra-ui/react");
var _atoms = require("@whitbread-eos/atoms");
var _nextI18next = require("next-i18next");
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function Discount(_ref) {
  var {
    value
  } = _ref;
  var {
    t
  } = (0, _nextI18next.useTranslation)();
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_react.Text, _objectSpread(_objectSpread({}, titleStyles), {}, {
      children: t('ccui.payment.confirmBooking.discount.title')
    })), (0, _jsxRuntime.jsx)(_react.Text, _objectSpread(_objectSpread({}, contentStyles), {}, {
      children: t('ccui.payment.discount.description')
    })), (0, _jsxRuntime.jsx)(_atoms.Input, {
      name: "amend-payment-discount",
      isDisabled: true,
      value: value,
      styles: {
        inputElementStyles
      }
    })]
  });
}
var titleStyles = {
  fontSize: '2xl',
  lineHeight: '4',
  fontWeight: 'semibold',
  color: 'darkGrey1',
  paddingBottom: 'md'
};
var contentStyles = {
  fontSize: 'md',
  lineHeight: '3',
  fontWeight: 'normal',
  color: 'darkGrey1',
  paddingBottom: 'sm'
};
var inputElementStyles = {
  width: '24.5rem'
};